<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/02d_Musei_Sala-Bronzi-RC-new.jpg">
<div class="content">
    <h1>Calabria</h1>
    <h3>Musei e siti archeologici</h3>
</div>
</div>
<br>
<div class="breadcrumb">
    <p><a>Scopri la Calabria</a> > <a class="active">Musei e siti archeologici</a></p>
</div>
<br>
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div style="text-align: center; margin-top: 30px;">
    <div class="textCenter">
        <p>
            Punta estrema dell’Italia e del Vecchio continente, terra ricca di risorse naturali,
             la Calabria è stata abitata sin da tempi antichissimi da popoli come gli Enotri e i Bruzi ed è stata attraversata da genti provenienti 
             tanto dal bacino del Mediterraneo, si pensi alla colonizzazione magno greca ma anche all’immigrazione basiliana e alle conquiste saracene,
              quanto da nord in epoca medievale, con l’avvicendarsi al governo della regione di longobardi, normanni e svevi.
            <br>
            <br>
            Le principali testimonianze delle origini dell’avventura umana si ritrovano nei siti preistorici di Papasidero, con la Grotta del romito, 
            a Sant’Agata d’Esaro nella Grotta della Monaca, a ridosso dei Monti dell’Orsomarso nel Parco nazionale del Pollino; più a sud, 
            sul Monte Tiriolo che domina i due mari, e poi sul Tirreno, a Zungri, dove sorge un vero e proprio insediamento rupestre di epoca preistorica.
            <br>
            <br>
            Tanti sono i Parchi e i Musei archeologici presenti, tra i più importanti quelli di Amendolara, Sibari, la potente città achea fondata nel 
            VII sec. a.C., Crotone e Capo Colonna, da cui Annibale ripartì per fare ritorno a Cartagine; e poi Scolacium, l’antica Skylletion magnograca 
            divenuta strategica colonia dei Romani; e ancora, sul versante jonico, Monasterace e Locri (Kaulon), e il Parco archeologico "Archeoderi" di Bova a 
            testimoniare le origini greche della cosiddetta “Bovesia” o “area grecanica”, caratterizzata tutt’oggi dall’uso della lingua madre. Ad ovest, invece, 
            si ritrovano Palmi, Gioia Tauro, Rosarno (Medma), Mileto, Vibo Valentia, Lamezia Terme e Santa Maria del Cedro, nel sito dell’antica città lucana di Laos. 
            Un patrimonio di storia e culture magnificamente raccontato dal Museo archeologico nazionale di Reggio Calabria (MArRC) che ha nei Bronzi di Riace, 
            capolavori della statuaria bronzea del V secolo a.C, l’espressione più alta ma che accoglie epresenta una ricca collezione di 
            reperti provenienti da tutto il territorio calabrese, dalla Preistoria alla tarda Età Romana.         
        </p>
    </div>
</div>
<!-- <br>
<br>
<div class="divider">

</div>
<br>
<br>
<div class="row bannerPollino">
    <div class="col-8">
        <h1 class="banner-header">ESPERIENZE E ITINERARI</h1>
        <br>
        <p>Scegli fra le tante idee di viaggio e proposte di itinerari tematici<br />per conoscere il Parco nazionale dell’Aspromonte.</p>
    </div>
    <div class="col-1">
        <img style="width: 65%;" src="../../../assets/images/logo-parco-top2.png">
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Sulle strade<br />della Ciclovia<br />dei Parchi</h1>
                        <a (click)="goToCiclovia()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Gerace</h1>
                        <a (click)="goToGerace()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Area grecanica</h1>
                        <a (click)="goToAreaGrecanica()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="divider">
    
</div> -->
<br>
<br>
<div class="slider">
    <owl-carousel-o [options]="customOptions">
        <ng-template carouselSlide>
            <div class="card museiCard">
                <img class="card-img-top" src="../../../assets/images/Musei/01_Galleria-Cosenza.jpg" alt="Card image cap">
                <div class="card-body">
                    <div class="card-content">
                                <h5 class="museiTitleCard">GALLERIA NAZIONALE DI COSENZA</h5>
                                <br>
                                <p class="museiText">
                                    La solenne architettura di Palazzo Arnone domina il centro storico di Cosenza dalla cima del colle Triglio. 
                                    Al suo interno ospita la Galleria Nazionale: un viaggio nell’arte dal ‘500 al Contemporaneo, 
                                    con sezioni dedicate ai pittori calabresi, ai protagonisti del ‘600 napoletano, a Umberto Boccioni e ai principali artisti del ‘900.
                                    <br>
                                    <br>
                                    Orari di apertura:
                                    <br>
                                    dal martedì alla domenica, 8:30 - 18:45
                                </p>
                                <a href="https://musei.calabria.beniculturali.it/musei?mid=80&nome=galleria-nazionale-di-cosenza" target="_blank" class="align-self-end btn btn-sm btn-primary museiDetailButton">Scopri</a>
                    </div>
                </div>
            </div>
        </ng-template>  
        <ng-template carouselSlide>
            <div class="card museiCard">
                <img class="card-img-top" src="../../../assets/images/Musei/02_museo SIBARITIDE.jpg" alt="Card image cap">
                <div class="card-body">
                    <div class="card-content">
                                <h5 class="museiTitleCard">MUSEO NAZIONALE ARCHEOLOGICO DELLA SIBARITIDE</h5>
                                <br>
                                <p class="museiText">
                                    Il Museo della Sibaritide, posto nelle immediate vicinanze della vasta area archeologica di Sibari-Thurii-Copia, 
                                    Raccoglie i reperti rinvenuti nel corso delle decennali indagini archeologiche condotte nel centro antico e nei siti più 
                                    significativi della Sibaritide e illustra con oggetti straordinari la lunga storia del territorio.
                                    <br>
                                    <br>
                                    Orari di apertura:
                                    <br>
                                    dal martedì alla domenica, 9:00 - 20:00                                    
                                </p>
                                <a href="https://parcosibari.it/?page_id=350" target="_blank" class="align-self-end btn btn-sm btn-primary museiDetailButton">Scopri</a>
                    </div>
                </div>
            </div>
        </ng-template>  
        <ng-template carouselSlide>
            <div class="card museiCard">
                <img class="card-img-top" src="../../../assets/images/Musei/03_Museo-Diocesano-e-del-Codex-Purpureus-Rossanensis-a-Rossano.jpg" alt="Card image cap">
                <div class="card-body">
                    <div class="card-content">
                                <h5 class="museiTitleCard">MUSEO DIOCESANO E DEL CODEX</h5>
                                <br>
                                <p class="museiText">
                                    Il percorso museale, di recente interamente rinnovato, si distingue in due sezioni, separate da un corridoio direzionale. 
                                    Una sezione è completamente dedicata al Codex Purpureus, uno dei più antichi evangeliari esistenti al mondo, mentre l’altra è 
                                    riservata alla storia della diocesi e della città di Rossano nei secoli.
                                    <br>
                                    <br>
                                    Orari di apertura:
                                    <br>
                                    dal martedì alla domenica, 8:30 - 18:45
                                </p>
                                <a href="https://www.museocodexrossano.it" target="_blank" class="align-self-end btn btn-sm btn-primary museiDetailButton">Scopri</a>
                    </div>
                </div>
            </div>
        </ng-template>  
        <ng-template carouselSlide>
            <div class="card museiCard">
                <img class="card-img-top" src="../../../assets/images/Musei/04_Museo-Crotone.jpg" alt="Card image cap">
                <div class="card-body">
                    <div class="card-content">
                                <h5 class="museiTitleCard">MUSEO ARCHEOLOGICO NAZIONALE DI CROTONE</h5>
                                <br>
                                <p class="museiText">
                                    Patria degli atleti più forti e vittoriosi del mondo greco e di grandi filosofi come Pitagora: 
                                    Kroton fu una delle città più ricche e potenti del mondo antico. La sua storia straordinaria è 
                                    raccontata dal Museo Archeologico Nazionale, che sorge sullo stesso luogo dell’antica acropoli greca.
                                    <br>
                                    <br>
                                    Orari di apertura:
                                    <br>
                                    dal martedì alla domenica, 9:00 – 20:00
                                </p>
                                <a href="https://www.beniculturali.it/luogo/museo-archeologico-nazionale-di-crotone" target="_blank" class="align-self-end btn btn-sm btn-primary museiDetailButton">Scopri</a>
                    </div>
                </div>
            </div>
        </ng-template>  
        <ng-template carouselSlide>
            <div class="card museiCard">
                <img class="card-img-top" src="../../../assets/images/Musei/05_Capo-Colonna.jpg" alt="Card image cap">
                <div class="card-body">
                    <div class="card-content">
                                <h5 class="museiTitleCard">PARCO ARCHEOLOGICO NAZIONALE DI CAPO COLONNA</h5>
                                <br>
                                <p class="museiText">
                                    Un luogo magico, una lingua di terra protesa nel blu del mare verso l’Oriente, un’unica colonna dell’antico tempio dedicato alla dea Hera, 
                                    divenuta simbolo della Calabria nel mondo. Il Museo e Parco Archeologico Nazionale di Capo Colonna racconta la storia di uno dei santuari più famosi dell’antichità.
                                    <br>
                                    <br>
                                    Orari di apertura:
                                    <br>
                                    dal martedì alla domenica, 9:00 - 19:00
                                </p>
                                <a href="https://musei.calabria.beniculturali.it/musei?mid=83&nome=museo-e-parco-archeologico-nazionale-di-capo-colonna" target="_blank" class="align-self-end btn btn-sm btn-primary museiDetailButton">Scopri</a>
                    </div>
                </div>
            </div>
        </ng-template>  
        <ng-template carouselSlide>
            <div class="card museiCard">
                <img class="card-img-top" src="../../../assets/images/Musei/06_Museo-Lametino.jpg" alt="Card image cap">
                <div class="card-body">
                    <div class="card-content">
                                <h5 class="museiTitleCard">MUSEO ARCHEOLOGICO LAMETINO</h5>
                                <br>
                                <p class="museiText">
                                    Dalle più antiche testimonianze preistoriche, ai preziosi reperti della città greca di Terina, fino alle fasi bizantine e medievali. 
                                    Il Museo racconta la millenaria storia della Piana di Sant’Eufemia. È ospitato nella cornice barocca del complesso monumentale di S. 
                                    Domenico, nel cuore del centro storico di Nicastro.
                                    <br>
                                    <br>
                                    Orari di apertura:
                                    <br>
                                    dal martedì alla domenica, 9:00 - 19:00
                                </p>
                                <a href="https://musei.calabria.beniculturali.it/musei?mid=1362&nome=museo-archeologico-lametino" target="_blank" class="align-self-end btn btn-sm btn-primary museiDetailButton">Scopri</a>
                    </div>
                </div>
            </div>
        </ng-template>  
        <ng-template carouselSlide>
            <div class="card museiCard">
                <img class="card-img-top" src="../../../assets/images/Musei/07_Le-Castella.jpg" alt="Card image cap">
                <div class="card-body">
                    <div class="card-content">
                                <h5 class="museiTitleCard">FORTEZZA LE CASTELLA</h5>
                                <br>
                                <p class="museiText">
                                    La grande torre cilindrica, le possenti mura e i bastioni costruiti dagli Aragonesi sembrano quasi galleggiare, 
                                    sospesi tra l’azzurro del cielo e le acque blu dello ionio. La Fortezza di Le Castella è un luogo straordinario, 
                                    un piccolo isolotto fortificato nel cuore dell’area marina protetta di “Capo Rizzuto”.
                                    <br>
                                    <br>
                                    Orari di apertura:
                                    <br>
                                    dal lunedì al venerdì 14:15 – 19:15,<br> sabato e domenica 8:15 – 19:15
                                </p>
                                <a href="https://storico.beniculturali.it/mibac/opencms/MiBAC/sito-MiBAC/Luogo/MibacUnif/Luoghi-della-Cultura/visualizza_asset.html?id=152989&pagename=157031" target="_blank" class="align-self-end btn btn-sm btn-primary museiDetailButton">Scopri</a>
                    </div>
                </div>
            </div>
        </ng-template>  
        <ng-template carouselSlide>
            <div class="card museiCard">
                <img class="card-img-top" src="../../../assets/images/Musei/08_Scolacium.jpg" alt="Card image cap">
                <div class="card-body">
                    <div class="card-content">
                                <h5 class="museiTitleCard">MUSEO E PARCO ARCHEOLOGICO NAZIONALE DI SCOLACIUM</h5>
                                <br>
                                <p class="museiText">
                                    Un Museo e un Parco, un connubio inscindibile tra storia e natura. Le strade, i templi, il teatro di una città romana, 
                                    i resti di castrum bizantino, le imponenti arcate della basilica medievale di S. Maria della Roccella, 
                                    custoditi da una sterminata distesa di ulivi secolari che lambiscono le acque turchesi dello Ionio calabrese.
                                    <br>
                                    <br>
                                    Orari di apertura:
                                    <br>
                                    dal martedì alla domenica, 9:00 – 16:30
                                </p>
                                <a href="https://www.beniculturali.it/luogo/museo-e-parco-archeologico-nazionale-di-scolacium" target="_blank" class="align-self-end btn btn-sm btn-primary museiDetailButton">Scopri</a>
                    </div>
                </div>
            </div>
        </ng-template>  
        <ng-template carouselSlide>
            <div class="card museiCard">
                <img class="card-img-top" src="../../../assets/images/Musei/09_Vibo_valentia-Capialbi.jpg" alt="Card image cap">
                <div class="card-body">
                    <div class="card-content">
                                <h5 class="museiTitleCard">MUSEO ARCHEOLOGICO NAZIONALE “VITO CAPIALBI” DI VIBO VALENTIA</h5>
                                <br>
                                <p class="museiText">
                                    Maestoso e austero, il castello medievale di Vibo Valentia domina il paesaggio circostante, 
                                    offrendo ai visitatori panorami mozzafiato sul Mar Tirreno, la Sicilia e le isole Eolie. 
                                    Al suo interno sono conservati i preziosi reperti dell’antica città greca di Hipponion, divenuta Vibo Valentia in età romana.
                                    <br>
                                    <br>
                                    Orari di apertura:
                                    <br>
                                    dal martedì alla domenica, 9:00 – 19:15
                                </p>
                                <a href="https://www.beniculturali.it/luogo/museo-archeologico-nazionale-vito-capialbi" target="_blank" class="align-self-end btn btn-sm btn-primary museiDetailButton">Scopri</a>
                    </div>
                </div>
            </div>
        </ng-template>  
        <ng-template carouselSlide>
            <div class="card museiCard">
                <img class="card-img-top" src="../../../assets/images/Musei/10_Museo-Mileto.jpg" alt="Card image cap">
                <div class="card-body">
                    <div class="card-content">
                                <h5 class="museiTitleCard">MUSEO STATALE DI MILETO</h5>
                                <br>
                                <p class="museiText">
                                    Una collezione di preziosi marmi antichi riutilizzati da Ruggero I il Normanno per decorare l’Abbazia della SS. 
                                    Trinità, uno dei più grandi e importanti monasteri del medioevo italiano. Preziosi cicli scultorei di età angioina, ceramiche, arredi sacri e dipinti, 
                                    che raccontano la storia dell’antica Mileto e del medioevo calabrese.
                                    <br>
                                    <br>
                                    Orari di apertura:
                                    <br>
                                    martedì e sabato, 15:00 – 20:00
                                    <br>
                                    mercoledì, giovedì, venerdì e domenica, 9:00 – 14:00

                                </p>
                                <a href="https://cultura.gov.it/luogo/museo-statale-di-mileto" target="_blank" class="align-self-end btn btn-sm btn-primary museiDetailButton">Scopri</a>
                    </div>
                </div>
            </div>
        </ng-template>  
        <ng-template carouselSlide>
            <div class="card museiCard">
                <img class="card-img-top" src="../../../assets/images/Musei/11_Metauros.jpg" alt="Card image cap">
                <div class="card-body">
                    <div class="card-content">
                                <h5 class="museiTitleCard">MUSEO ARCHEOLOGICO MÉTAUROS</h5>
                                <br>
                                <p class="museiText">
                                    Un’area a vocazione portuale fin dall’antichità, da sempre la porta del Mediterraneo verso l’Europa. 
                                    Il Museo, ospitato settecentesco palazzo Baldari, racconta la storia dell’antica Mètauros (oggi Gioia Tauro), 
                                    centro emporico controllato dai Greci, poi stazione di sosta romana e infine fiorente centro medievale.
                                    <br>
                                    <br>
                                    Orari di apertura:
                                    <br>
                                    lunedì e mercoledì, 8:00 – 13:30  / 14:00 – 17:00
                                    <br>
                                    martedì, giovedì e venerdì, 8:00 – 13:30
                                </p>
                                <a href="https://www.beniculturali.it/luogo/museo-archeologico-metauros" target="_blank" class="align-self-end btn btn-sm btn-primary museiDetailButton">Scopri</a>
                    </div>
                </div>
            </div>
        </ng-template>  
        <ng-template carouselSlide>
            <div class="card museiCard">
                <img class="card-img-top" src="../../../assets/images/Musei/12_Cattolica-Stilo.jpg" alt="Card image cap">
                <div class="card-body">
                    <div class="card-content">
                                <h5 class="museiTitleCard">CATTOLICA DI STILO</h5>
                                <br>
                                <p class="museiText">
                                    I preziosi cicli di affreschi, l’inconfondibile profilo delle sue cupole, il contesto ambientale e paesaggistico unico. 
                                    Adagiata, quasi nascosta tra le rocce del Monte Consolino, la Cattolica di stilo è un vero e proprio gioiello dell’architettura medievale, 
                                    il simbolo più noto del passato greco-bizantino della Calabria.
                                    <br>
                                    <br>
                                    Orari di apertura:
                                    <br>
                                    dal lunedì alla domenica, 8:00 – 19:30
                                </p>
                                <a href="https://musei.calabria.beniculturali.it/musei?mid=814&nome=la-cattolica" target="_blank" class="align-self-end btn btn-sm btn-primary museiDetailButton">Scopri</a>
                    </div>
                </div>
            </div>
        </ng-template>  
        <ng-template carouselSlide>
            <div class="card museiCard">
                <img class="card-img-top" src="../../../assets/images/Musei/13_KAULON.jpg" alt="Card image cap">
                <div class="card-body">
                    <div class="card-content">
                                <h5 class="museiTitleCard">MUSEO E PARCO ARCHEOLOGICO DELL’ANTICA KAULON</h5>
                                <br>
                                <p class="museiText">
                                    I resti dell’antica polis greca di Kaulonia, le sue mura, i suoi templi, le sue case decorate da splendidi mosaici di età ellenistica, 
                                    tra i più importanti del Mediterraneo occidentale. Il Museo e Parco Archeologico dell’Antica Kaulonia si 
                                    affaccia direttamente sulle splendide acque turchesi dello Ionio.
                                    <br>
                                    <br>
                                    Orari di apertura:
                                    <br>
                                    dal martedì alla domenica, 9:00 – 18:30
                                </p>
                                <a href="https://www.beniculturali.it/luogo/museo-e-parco-archeologico-dell-antica-kaulon" target="_blank" class="align-self-end btn btn-sm btn-primary museiDetailButton">Scopri</a>
                    </div>
                </div>
            </div>
        </ng-template>  
        <ng-template carouselSlide>
            <div class="card museiCard">
                <img class="card-img-top" src="../../../assets/images/Musei/14_San-Francesco-Gerace.jpg" alt="Card image cap">
                <div class="card-body">
                    <div class="card-content">
                                <h5 class="museiTitleCard">CHIESA DI SAN FRANCESCO D’ASSISI DI GERACE</h5>
                                <br>
                                <p class="museiText">
                                    Un maestoso portale a sesto acuto, decorato con stilemi di origine araba, preziosi sarcofagi quattrocenteschi, 
                                    un meraviglioso altare barocco a intarsi marmorei. La chiesa di San Francesco a Gerace è un gioiello dell’architettura gotica, 
                                    uno scrigno di opere d’arte nel cuore di uno dei Borghi più belli d’Italia.
                                    <br>
                                    <br>
                                    Orari di apertura:
                                    <br>
                                    dal lunedì alla domenica, 8:00 – 20:00
                                </p>
                                <a href="https://musei.calabria.beniculturali.it/musei?mid=813&nome=chiesa-di-san-francesco-dassisi" target="_blank" class="align-self-end btn btn-sm btn-primary museiDetailButton">Scopri</a>
                    </div>
                </div>
            </div>
        </ng-template>  
        <ng-template carouselSlide>
            <div class="card museiCard">
                <img class="card-img-top" src="../../../assets/images/Musei/15_Parco archeologico Locri.jpg" alt="Card image cap">
                <div class="card-body">
                    <div class="card-content">
                                <h5 class="museiTitleCard">MUSEO E PARCO ARCHEOLOGICO NAZIONALE DI LOCRI</h5>
                                <br>
                                <p class="museiText">
                                    Stretta tra i primi contrafforti dell’Aspromonte e il mare, Locri Epizefiri fu una delle più importanti poleis greche d’Italia, 
                                    sacra alla dea Persefone e patria della prima legislazione scritta del mondo occidentale. 
                                    Tre Musei e un Parco Archeologico raccontano oggi al visitatore i suoi tremila anni di storia.
                                    <br>
                                    <br>
                                    Orari di apertura:
                                    <br>
                                    dal mercoledì alla domenica, 9:00 – 20:00
                                </p>
                                <a href="http://musei.beniculturali.it/musei?mid=84&nome=" target="_blank" class="align-self-end btn btn-sm btn-primary museiDetailButton">Scopri</a>
                    </div>
                </div>
            </div>
        </ng-template>  
        <ng-template carouselSlide>
            <div class="card museiCard">
                <img class="card-img-top" src="../../../assets/images/Musei/16_Parco_Archeoderi.jpg" alt="Card image cap">
                <div class="card-body">
                    <div class="card-content">
                                <h5 class="museiTitleCard">MUSEO E PARCO ARCHEOLOGICO ARCHEODERI DI BOVA MARINA</h5>
                                <br>
                                <p class="museiText">
                                    Gli affascinanti resti di una delle sinagoghe ebraiche più antiche d’Occidente e un paesaggio straordinario che abbraccia il mare fino alla Sicilia. 
                                    Il Museo e il Parco Archeologico Archeoderi di Bova Marina è situato nel cuore dell’area grecanica,
                                     dove gli abitanti parlano ancora l’antica lingua greca di Calabria.
                                    <br>
                                    <br>
                                    Orari di apertura:
                                    <br>
                                    dal mercoledì al sabato, 9:00 – 17:00
                                </p>
                                <a href="http://musei.beniculturali.it/musei?mid=1366&nome=museo-e-parco-archeologico-archeoderi" target="_blank" class="align-self-end btn btn-sm btn-primary museiDetailButton">Scopri</a>
                    </div>
                </div>
            </div>
        </ng-template>  
        <ng-template carouselSlide>
            <div class="card museiCard">
                <img class="card-img-top" src="../../../assets/images/Musei/17_Reggio-Bronzi.jpg" alt="Card image cap">
                <div class="card-body">
                    <div class="card-content">
                                <h5 class="museiTitleCard">MUSEO ARCHEOLOGICO NAZIONALE DI REGGIO CALABRIA - MArRC</h5>
                                <br>
                                <p class="museiText">
                                    È uno dei Musei archeologici più rappresentativi del periodo della Magna Grecia e della Calabria antica. 
                                    Noto al mondo per l'esposizione permanente dei famosi Bronzi di Riace, capolavori della statuaria bronzea del V secolo a.C., 
                                    accoglie una ricca collezione di reperti provenienti da tutto il territorio calabrese, dalla Preistoria alla tarda Età Romana.
                                    <br>
                                    <br>
                                    Orari di apertura:
                                    <br>
                                    dal martedì alla domenica, 9:00 – 20:00
                                </p>
                                <a href="https://www.museoarcheologicoreggiocalabria.it" target="_blank" class="align-self-end btn btn-sm btn-primary museiDetailButton">Scopri</a>
                    </div>
                </div>
            </div>
        </ng-template>  
        <ng-template carouselSlide>
            <div class="card museiCard">
                <img class="card-img-top" src="../../../assets/images/Musei/18_castello-ducale_Corigliano.jpg" alt="Card image cap">
                <div class="card-body">
                    <div class="card-content">
                                <h5 class="museiTitleCard">CASTELLO DUCALE DI CORIGLIANO CALABRO</h5>
                                <br>
                                <p class="museiText">
                                    Il Castello impreziosito dai lavori commissionati dal conte Bernardino Sanseverino e poi dai duchi di Saluzzo fra il XVI e il XII sec, 
                                    è oggi un Museo visitabile; si possono ammirare le prigioni, le cucine e le stanze signorili il Salone degli Specchi, 
                                    la torre Mastio, la cappella di Sant’Agostino e il trittico della Madonna delle Rose.
                                    <br>
                                    <br>
                                    Orari di apertura:
                                    <br>
                                    invernale, da martedì a domenica, 09:30 – 13:00 / 15:00 – 18:30
                                    <br>
                                    estivo, da martedì a domenica, 10:00 – 13:00 / 16:30 – 20:30
                                </p>
                                <a href="https://www.castellodicoriglianocalabro.com" target="_blank" class="align-self-end btn btn-sm btn-primary museiDetailButton">Scopri</a>
                    </div>
                </div>
            </div>
        </ng-template>  
      </owl-carousel-o>
</div>
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>